// @flow

import React, { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/core';

type PBSImageProps = {
  id?: string,
  emoCSS?: any,
  url: string,
  imageSizes: {
    min: number,
    max: number,
    step: number
  },
  aspectRatio: number,
  sizes: Array<Size>,
  alt: string,
  ariaHidden: boolean
};

type Size = {
  breakpoint: string,
  width: string
};

type Defaults = {|
  ariaHidden: boolean
    |};

class PBSImage extends React.PureComponent<PBSImageProps> {
  static defaultProps: Defaults;

  render() {
    let srcset = '';
    let url = this.props.url.replace(/http:/, '');

    if (url == '')
    {
      let defaultImage = `/content/themes/tpt/dist/images/default-post-image-600.jpg`;
      let defaultSrcSet = '/content/themes/tpt/dist/images/default-post-image-600.jpg 700w, /content/themes/tpt/dist/images/default-post-image-600.jpg 550w, /content/themes/tpt/dist/images/default-post-image-600.jpg 400w, /content/themes/tpt/dist/images/default-post-image-600.jpg 100w';

      url = defaultImage;
      srcset = defaultSrcSet;
    }
    else
    {
      if (this.props.imageSizes) {
        for (let size = this.props.imageSizes.max; size >= this.props.imageSizes.min; size -= this.props.imageSizes.step) {
          srcset += url + '.resize.' + size + 'x' + Math.floor(size * this.props.aspectRatio) + '.jpg ' + size + 'w';

          if (size > this.props.imageSizes.min) {
            srcset += ', ';
          }
        }
      }

      this.sizes = this.props.sizes.reduce(function (sizes, size) {
        return sizes + ' (min-width: ' + size['breakpoint'] + ') ' + size['width'] + ', ';
      }, '') + '100vw';
    }

    return (
      <img
        id={this.props.id || ''}
        css={this.props.emoCSS || ''}
        src={url}
        srcSet={srcset}
        sizes={this.sizes}
        alt={this.props.alt || ''}
        aria-hidden={this.props.ariaHidden} />
    );
  }
}

PBSImage.defaultProps = {
  ariaHidden: false
};

export default PBSImage